"use client";
import { FormattedMedia } from "@/lib/centra/atomics/media";
import clsx from "clsx";
import Image, { ImageProps } from "next/image";
import { Dispatch, SetStateAction, lazy } from "react";
import styles from "./index.module.css";

const ZoomDialog = lazy(() => import("./ZoomDialog"));

/**
 * Extension of Next Image with fill that allows zooming in on the image
 */

export interface ZoomProps {
  setCurrent: Dispatch<SetStateAction<number>>;
  current: number;
  media: FormattedMedia[];
  setZoom: Dispatch<SetStateAction<boolean>>;
  setSecondSwiper?: any;
  firstSwiper?: any;
}

const ZoomImage = ({
  setZoom,
  src,
  className,
  alt,
  fill: _,
  setCurrent: __,
  ...rest
}: ImageProps & ZoomProps) => {
  const fill = true;
  return (
    <>
      <figure>
        <span title="show zoomed" aria-hidden onClick={() => setZoom(true)}>
          <Image
            src={src}
            fill={fill}
            className={clsx(styles.image, className)}
            alt={alt}
            sizes="100vw"
            {...rest}
          />
        </span>
      </figure>
    </>
  );
};

export default ZoomImage;
